export default __webpack_public_path__ + "static/media/scooter.3d51e6b2.svg";